// import React, { Suspense } from "react";
import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
// import myLogo from "./assets/images/logo.png";
// import * as serviceWorkerRegistration from "./service-worker";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./index.css";
// import Spinner from "./components/spinner/Spinner";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <Suspense fallback={<Spinner />}> */}
      <Provider store={store}>
        <App />
      </Provider>
    {/* </Suspense> */}
  </React.StrictMode>
);

// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     const confirmationMessage = `New update is available. Click OK to reload.`;
//     if (window.confirm(confirmationMessage)) {
//       registration.waiting.postMessage({ type: "SKIP_WAITING" });
//     }
//   },
// });

reportWebVitals();
